import { CommonModule } from '@angular/common';
import { inject } from "@angular/core";
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { Store } from '@ngxs/store';
import { VersioncheckActions, VersioncheckState } from './versioncheck.state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../../../../../ui/frontend-shared/src/lib/icons/icon.component";
import * as i3 from "@angular/common";
function CoreVersioncheckComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
    i0.ɵɵtext(3, "Neue Version verf\u00FCgbar. Bitte aktualisieren Sie die Seite!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 3)(5, "button", 4);
    i0.ɵɵlistener("click", function CoreVersioncheckComponent_Conditional_0_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClickReload());
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "div", 5)(7, "a", 6);
    i0.ɵɵlistener("click", function CoreVersioncheckComponent_Conditional_0_Template_a_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.postpone());
    });
    i0.ɵɵelement(8, "ui-icon", 7);
    i0.ɵɵelementEnd()()();
  }
}
export let CoreVersioncheckComponent = /*#__PURE__*/(() => {
  class CoreVersioncheckComponent {
    constructor(store) {
      this.store = store;
      this.enableOverlay = false;
      this.newVersionAvailable$ = inject(Store).select(VersioncheckState.newVersionAvailable);
      this.newVersionAvailable$.subscribe(avail => {
        this.enableOverlay = avail;
      });
    }
    onClickReload() {
      window.location.reload();
    }
    postpone() {
      this.store.dispatch(new VersioncheckActions.PostponeUpdate());
    }
    static {
      this.ɵfac = function CoreVersioncheckComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreVersioncheckComponent)(i0.ɵɵdirectiveInject(i1.Store));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CoreVersioncheckComponent,
        selectors: [["core-versioncheck"]],
        hostVars: 2,
        hostBindings: function CoreVersioncheckComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("overlay", ctx.enableOverlay);
          }
        },
        decls: 2,
        vars: 3,
        consts: [[1, "infobar"], [1, "center"], [1, "infotext"], [1, "mobile-block"], ["uiButton", "", "label", "Aktualisieren", 1, "ui-button-outline", 3, "click"], [1, "right"], [3, "click"], ["icon", "times", "size", "lg"]],
        template: function CoreVersioncheckComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CoreVersioncheckComponent_Conditional_0_Template, 9, 0, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.newVersionAvailable$) ? 0 : -1);
          }
        },
        dependencies: [CommonModule, UiButtonComponent, UiIconsModule, i2.UiIconComponent, i3.AsyncPipe],
        styles: ["[_nghost-%COMP%]{position:fixed;top:0;left:0;right:0;z-index:9999;background:#0000;transition:background-color .3s}.infobar[_ngcontent-%COMP%]{background:var(--primaryColor);color:var(--primaryTextColor);padding:10px 20px;display:flex;justify-content:center;align-items:center}.infobar[_ngcontent-%COMP%]{transform:translateY(-60px);transition:transform .3s}.infobar[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{position:absolute;right:10px;top:16px}.infobar[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .infobar[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{color:var(--primaryTextColor)}.infobar[_ngcontent-%COMP%]   .ui-button-outline[_ngcontent-%COMP%]{border-color:var(--primaryTextColor);border-width:2px}@media (max-width: 767px){.infobar[_ngcontent-%COMP%]   .infotext[_ngcontent-%COMP%]{display:block;margin:0 10px 5px 0}.infobar[_ngcontent-%COMP%]   .mobile-block[_ngcontent-%COMP%]{display:block;text-align:center}.infobar[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{top:10px}}@media (min-width: 768px){.infobar[_ngcontent-%COMP%]   .infotext[_ngcontent-%COMP%], .infobar[_ngcontent-%COMP%]   .mobile-block[_ngcontent-%COMP%]{display:inline}.infobar[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:0 10px}}.overlay[_nghost-%COMP%]{bottom:0;background:#0000004d}.overlay[_nghost-%COMP%]   .infobar[_ngcontent-%COMP%]{transform:translateY(0)}@media (prefers-color-scheme: dark){.overlay[_nghost-%COMP%]{background:#0009}}"]
      });
    }
  }
  return CoreVersioncheckComponent;
})();